
<div v-if="context !== null && context.customer != null" class="primary">
    <d-site
        v-model    = "siteDialog"
        :site-id   = "siteId"
        :tab-index = "siteTabIndex"
        @close     = "siteTabIndex = 0"
        @customer  = "onCustomer"
    />

    <v-row class="no-frame">
        <v-col class="no-frame col-6 v-flex">
            <c-site-title
                :site      = "context"
                :hide-type = "true"
                class      = "mr-3"
                style      = "margin-top: -5px"
            />

            <div
                class = "v-flex"
                style = "margin-top: -3px"
            >
                <div class="v-flex">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on: tooltip }">
                            <a
                                v-on   = "{ ...tooltip }"
                                @click.prevent="onEdit"
                            >
                                <v-icon color="white" :class="stops ? 'red' : ''" size="23">{{ context.type.symbol }}</v-icon>
                            </a>
                        </template>
                        <div>
                            <div style="text-align: center">
                                {{ $t("unit.menu.siteedit") }}
                            </div>
                            <div v-if="stops" class="red pl-3 pr-2 pt-1 pb-1 mt-2" style="border-radius: 10px;">
                                Die Anlage hat {{ stops }} Stockwerke
                            </div>
                        </div>
                    </v-tooltip>

                    <v-tooltip bottom v-if="liftmanager">
                        <template v-slot:activator="{ on: tooltip }">
                            <a
                                v-on   = "{ ...tooltip }"
                                @click.prevent="onIncidents"
                            >
                                <v-icon color="white" size="25">mdi-format-list-bulleted</v-icon>
                            </a>
                        </template>
                        <span>{{ $t("unit.menu.incidents") }}</span>
                    </v-tooltip>

                    <c-site-liftguardian
                        class="ml-3"
                        :context = "context"
                    />
                </div>
            </div>

            <v-spacer/>
            <c-inc-navigation />
        </v-col>
        <v-col class="no-frame col-3">
            <c-inc-maintenance-state
                :site    = "context"
                @details = "onSiteDialog(9)"
            />
        </v-col>

        <v-col class="no-frame col-3" >
            <c-site-title-row-assessment
                :site    = "context"
                @details = "onSiteDialog(10)"
            />
        </v-col>
    </v-row>
</div>
